import { useContext } from 'react'
import { AgencyContext } from 'Context/Agency';

const SealUnsealSidebar = () => {
    const { sealUnsealPage, setSealUnsealPage } = useContext(AgencyContext);


    // Navigation Item Component
    const NavItem = ({ page, label }) => {
        const isActive = sealUnsealPage === page;

        return (
            <div
                onClick={() => setSealUnsealPage(page)}
                className={`pl-3 py-2 d-flex align-items-center border-start border-3 transition-all ${isActive ? 'case-management-sidebar' : ''} cursor-pointer`}
                onMouseEnter={(e) => {
                    if (!isActive) {
                        e.currentTarget.classList.add('case-management-sidebar-hover');
                    }
                }}
                onMouseLeave={(e) => {
                    if (!isActive) {
                        e.currentTarget.classList.remove('case-management-sidebar-hover');
                    }
                }}
                style={{ fontSize: '14px', gap: "6px" }}
            >
                <span
                    className="text-nowrap"
                    style={{
                        fontWeight: isActive ? '600' : '500',
                        color: isActive ? 'white' : 'inherit',
                    }}
                >
                    {label}
                </span>
            </div>
        );
    };

    return (
        <>
            <div className="w-100">
                {/* Navigation Sections */}
                <div>
                    <div className="mb-2">
                        <div>
                            <NavItem page="seal" label="Seal" />
                            <NavItem page="unseal" label="Unseal" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SealUnsealSidebar
